// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Quotes_wrapper__1hiyC","buttons":"Quotes_buttons__2sb0Z","singleButton":"Quotes_singleButton__3MDbW","button":"Quotes_button__1xRu6","summary":"Quotes_summary__3uCtY"};